<template>
  <div class="finding">
    <div class="comments-section">
      <label
        class="label"
        v-if="result.finding.hasComments() || result.finding.hasPendingComment()"
        :size="4"
        :lineSeparator="'under'"
        v-translate>
        Comments:
      </label>
      <template v-if="result.finding && result.finding.created">
        <comment-finding-list-component
          :finding="result.finding">
        </comment-finding-list-component>
      </template>
    </div>
    <div class="field" v-if="result.finding.hasPendingComment()">
      <label class="label" v-translate>Comment:</label>
      <div class="control">
        <textarea
          class="textarea" :class="{ 'is-danger': !is_valid }"
          v-on:keyup="removeValidation()"
          v-model="result.finding.pendingComment.text"
          cols="30" rows="5" :placeholder="'Reject comment' | translate">
        </textarea>
        <p class="help is-danger"
           v-if="!is_valid"
           v-translate>
          Rejection comment is required!
        </p>
      </div>
    </div>
    <div class="field is-grouped">
      <div class="control">
        <button class="button is-success is-outlined" @click="setReviewResultState(result, reviewResultState.OK)" v-translate>Approve</button>
      </div>
      <div class="control is-right">
        <button class="button is-danger is-outlined" @click="commitRejection(result)" v-translate>Reject</button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapMutations } from 'vuex'
  import ProfileType from '@/classes/auth/ProfileType'
  import CommentFindingListComponent from '@/components/layout/utility/CommentFindingListComponent'
  import { ReviewResultState } from '@/classes/case/ReviewResult'
  import { errorHandler } from '@/mixins/mixins'

  export default {
    name: 'finding-approval-component',
    mixins: [errorHandler],
    components: {
      CommentFindingListComponent
    },
    data () {
      return {
        is_valid: true,
        reviewResultState: ReviewResultState
      }
    },
    props: {
      result: {
        required: true
      },
      caseId: {
        required: true
      }
    },
    methods: {
      ...mapActions([
        'setCase',
        'saveRejectComment',
        'updateReviewResultState'
      ]),
      ...mapMutations([
        'setResponsibleOnResult',
        'setStateReviewResultState'
      ]),
      setReviewResultState (reviewResult, state) {
        let data = { reviewResult: reviewResult, state: state }
        let savedState = reviewResult.state.value
        this.setStateReviewResultState(data)
        this.updateReviewResultState(data).then((response) => {
          // Update case data
          this.setCase(this.caseId).catch((err) => {
            this.handleError(err)
          })
          // Discard saved state
          savedState = null
        }).catch((err) => {
          data.state = savedState
          this.setStateReviewResultState(data)
          this.handleError(err)
        })
      },
      commitRejection (reviewResult) {
        if (reviewResult.finding.pendingComment.text) {
          let responsible = {
            profile_type_id: ProfileType.CUSTOMER,
            profile_type_display: ProfileType.getProfileTypeDisplay(ProfileType.CUSTOMER)
          }
          this.setResponsibleOnResult({ reviewResult: reviewResult, responsible: responsible })
          let comment = reviewResult.finding.pendingComment
          let postData = {
            finding: reviewResult.finding,
            comment: comment.text,
            responsible: responsible
          }
          this.saveRejectComment(postData).then((response) => {
            this.setReviewResultState(this.result, this.reviewResultState.NOT_OK)
          }).catch((err) => {
            this.handleError(err)
          })
        } else {
          this.is_valid = false
        }
      },
      removeValidation () {
        this.is_valid = true
      }
    }
  }
</script>
